export function useVpeUrl() {
  const config = useRuntimeConfig()
  const vpeUrl = config.public.ADMIN_ENDPOINT

  return { vpeUrl }
}
